import React, { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
// material-ui
import { createStyles, useTheme } from "@mui/material/styles";
import {
  Card,
  CardContent,
  CardMedia,
  Container,
  FormControl,
  Grid,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { IconCircleCheck } from "@tabler/icons";

// project imports
import AnimateButton from "@stories/ui-component/extended/AnimateButton";

// assets
import mailImg from "assets/images/landing/widget-mail.svg";
import { gridSpacing } from "constant";
import { StyledButton } from "@stories/atoms/StyledButton/StyledButton";
import LongBlueLine from "assets/images/landing/Long Line _ blue.png";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import { StyledTextField } from "@stories/atoms/StyledTextField/StyledTextField";
import { ToastOptions, toast } from "react-toastify";

// select options
const currencies = [
  {
    value: "1",
    label: "Below $1000",
  },
  {
    value: "2",
    label: "$1000 - $5000",
  },
  {
    value: "3",
    label: "Not specified",
  },
];

const sizes = [
  {
    value: "1",
    label: "1 - 5",
  },
  {
    value: "2",
    label: "5 - 10",
  },
  {
    value: "3",
    label: "10+",
  },
];

// ===========================|| CONTACT CARD - FORMS ||=========================== //

export const sendContactEmail = async (email: string, subject: string, message: string) => {
  const res = await fetch(`https://f8gtp0moq5.execute-api.ap-southeast-2.amazonaws.com/dev/signIn`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, subject, message }),
  });
  return res.json();
};

export const verifyRecaptcha = async (token: string) => {
  const res = await fetch(`https://f8gtp0moq5.execute-api.ap-southeast-2.amazonaws.com/dev/signIn`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  return res.json();
};

export const ContactForm = () => {
  const theme = useTheme();
  const captchaRef = useRef<ReCAPTCHA>(null);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Must be a valid email").max(255).required("Email is required"),
    subject: Yup.string().required("Subject is required"),
    message: Yup.string().required("Message is required"),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
      subject: "",
      message: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (captchaRef.current) {
        try {
          const token = captchaRef.current.getValue();
          if (token) {
            const res = await verifyRecaptcha(token);
            if (res.status) {
              sendContactEmail(values.email, values.subject, values.message);
              toast("Message sent - we will respond shortly!", {
                type: "success",
              } as ToastOptions);
              formik.resetForm();
            } else {
              toast("Recaptcha failed! Nice try, robot.", {
                type: "error",
              } as ToastOptions);
            }
            captchaRef.current.reset();
          }
        } catch (e) {
          toast("Failed to send - something went wrong!", {
            type: "error",
          } as ToastOptions);
        }
      }
    },
  });

  const listSX = {
    display: "flex",
    alignItems: "center",
    gap: "0.7rem",
    padding: "10px 0",
    fontSize: "1rem",
    color: theme.palette.grey[900],
    svg: { color: theme.palette.secondary.main },
  };

  return (
    // <Container maxWidth="xl">
    //   <Grid container justifyContent="center" spacing={gridSpacing}>
    //     <Grid
    //       container
    //       justifyContent="space-between"
    //       alignItems="center"
    //       spacing={{ xs: 1.5, sm: 2.5, md: 3, lg: 5 }}
    //     >
    //       <Grid item xs={12} md={6}>
    //         <Grid
    //           container
    //           spacing={2.5}
    //           direction={{ xs: "column-reverse", md: "row" }}
    //         >
    //           <Typography
    //             variant="h5"
    //             sx={{
    //               fontSize: { xs: "0.5rem", sm: "1.125rem" },
    //               mb: 2,
    //             }}
    //           >
    //             CONTACT
    //           </Typography>
    //           <Typography
    //             variant="h1"
    //             color="text.primary"
    //             sx={{
    //               zIndex: "99",
    //               fontSize: "3.5rem",
    //               color: theme.palette.primary.main,
    //               textAlign: "center",
    //             }}
    //           >
    //             Send us a message to learn more
    //           </Typography>
    //           <CardMedia
    //             component="img"
    //             src={LongBlueLine}
    //             alt="Social Procurement"
    //             sx={{ marginTop: "1rem" }}
    //           />
    //         </Grid>
    //         <Grid item xs={12}>
    //           <Typography sx={listSX}>
    //             <IconCircleCheck size={20} />
    //             Request a demo.
    //           </Typography>
    //           <Typography sx={listSX}>
    //             <IconCircleCheck size={20} />
    //             Plans & Pricing
    //           </Typography>
    //           <Typography sx={listSX}>
    //             <IconCircleCheck size={20} />
    //             Product Capabilities
    //           </Typography>
    //           <Typography sx={listSX}>
    //             <IconCircleCheck size={20} />
    //             Training & Support Services
    //           </Typography>
    //           <Typography sx={listSX}>
    //             <IconCircleCheck size={20} />
    //             Business Solutions
    //           </Typography>

    //           <Typography sx={listSX}>
    //             <IconCircleCheck size={20} />
    //             Software Integrations
    //           </Typography>
    //         </Grid>
    //       </Grid>
    //       <Grid item xs={12} md={6} sx={{ img: { width: "100%" } }}>
    //         <Grid container justifyContent="center" spacing={gridSpacing}>
    //           <Grid
    //             item
    //             xs={12}
    //             sx={{
    //               position: "relative",
    //               display: { xs: "none", lg: "block" },
    //             }}
    //           >
    //             <img
    //               src={mailImg}
    //               alt="Berry"
    //               style={{
    //                 marginBottom: -0.625,
    //                 position: "absolute",
    //                 bottom: -90,
    //                 right: "0",
    //                 width: 300,
    //                 maxWidth: "100%",
    //                 animation: "5s wings ease-in-out infinite",
    //               }}
    //             />
    //           </Grid>
    //           <Grid item xs={10} sx={{ mb: -37.5 }}>
    //             <Card sx={{ mb: 6.25 }} elevation={4}>
    //               <CardContent sx={{ pl: 4 }}>
    //                 <form onSubmit={formik.handleSubmit}>
    //                   <Grid container spacing={gridSpacing}>
    //                     <Grid item xs={12} sm={12}>
    //                       <Typography variant="h3">Get in touch</Typography>
    //                     </Grid>
    //                     <Grid item xs={12} sm={12}>
    //                       <FormControl fullWidth>
    //                         <StyledTextField
    //                           id="email"
    //                           name="email"
    //                           fullWidth
    //                           margin="dense"
    //                           label="Email"
    //                           disabled={formik.isSubmitting}
    //                           onChange={formik.handleChange}
    //                           onBlur={formik.handleBlur}
    //                           value={formik.values.email}
    //                           error={
    //                             formik.touched.email &&
    //                             Boolean(formik.errors.email)
    //                           }
    //                           helperText={
    //                             formik.touched.email ? formik.errors.email : ""
    //                           }
    //                         />
    //                       </FormControl>
    //                     </Grid>
    //                     <Grid item xs={12} sm={12}>
    //                       <FormControl fullWidth>
    //                         <StyledTextField
    //                           id="subject"
    //                           name="subject"
    //                           fullWidth
    //                           margin="dense"
    //                           label="Subject"
    //                           disabled={formik.isSubmitting}
    //                           onChange={formik.handleChange}
    //                           onBlur={formik.handleBlur}
    //                           value={formik.values.subject}
    //                           error={
    //                             formik.touched.subject &&
    //                             Boolean(formik.errors.subject)
    //                           }
    //                           helperText={
    //                             formik.touched.subject
    //                               ? formik.errors.subject
    //                               : ""
    //                           }
    //                         />
    //                       </FormControl>
    //                     </Grid>
    //                     <Grid item xs={12}>
    //                       <FormControl fullWidth>
    //                         <StyledTextField
    //                           id="message"
    //                           name="message"
    //                           label="Message"
    //                           fullWidth
    //                           margin="dense"
    //                           disabled={formik.isSubmitting}
    //                           onChange={formik.handleChange}
    //                           onBlur={formik.handleBlur}
    //                           value={formik.values.message}
    //                           error={
    //                             formik.touched.message &&
    //                             Boolean(formik.errors.message)
    //                           }
    //                           helperText={
    //                             formik.touched.message
    //                               ? formik.errors.message
    //                               : ""
    //                           }
    //                           multiline
    //                           rows={4}
    //                           placeholder="Message"
    //                         />
    //                       </FormControl>
    //                     </Grid>
    //                     <Grid item xs={12}>
    //                       <FormControl fullWidth>
    //                         <ReCAPTCHA
    //                           ref={captchaRef}
    //                           sitekey="6Le2DL0mAAAAAHGi46Uf3NpJS7yRih2-gNExcpS4"
    //                           aria-disabled={formik.isSubmitting}
    //                         />
    //                       </FormControl>
    //                     </Grid>
    //                     <Grid item xs={12}>
    //                       <Grid container spacing={gridSpacing}>
    //                         <Grid item>
    //                           <AnimateButton>
    //                             <StyledButton
    //                               variant="contained"
    //                               color="secondary"
    //                               type="submit"
    //                               disabled={formik.isSubmitting}
    //                             >
    //                               Send
    //                             </StyledButton>
    //                           </AnimateButton>
    //                         </Grid>
    //                       </Grid>
    //                     </Grid>
    //                   </Grid>
    //                 </form>
    //               </CardContent>
    //             </Card>
    //           </Grid>
    //         </Grid>
    //       </Grid>
    //     </Grid>
    //   </Grid>
    // </Container>
    <form onSubmit={formik.handleSubmit}>
      <div className="form-control-new">
        <label className="form-label-new">Email*</label>
        <div className="contact-form">
          <input
            type="email"
            id="email"
            disabled={formik.isSubmitting}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            placeholder="e.g., email@example.com"
          />
        </div>
      </div>
      <div className="form-control-new">
        <label className="form-label-new">Subject*</label>
        <div className="contact-form">
          <input
            type="subject"
            id="subject"
            disabled={formik.isSubmitting}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.subject}
            placeholder="e.g., Support"
          />
        </div>
      </div>
      <div className="form-control-new">
        <label className="form-label-new">Message*</label>
        <div className="contact-form">
          <textarea
            id="message"
            name="message"
            disabled={formik.isSubmitting}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.message}
            rows={4}
            placeholder="Enter text here"
          ></textarea>
        </div>
      </div>
      <FormControl fullWidth>
        <ReCAPTCHA
          ref={captchaRef}
          sitekey="6Le2DL0mAAAAAHGi46Uf3NpJS7yRih2-gNExcpS4"
          aria-disabled={formik.isSubmitting}
        />
      </FormControl>

      <button type="submit" className="contact-form-btn" disabled={formik.isSubmitting}>
        Send
      </button>
      {/* <AnimateButton>
        <StyledButton variant="contained" color="secondary" type="submit" disabled={formik.isSubmitting}>
          Send
        </StyledButton>
      </AnimateButton> */}
    </form>
  );
};
